// 把 Blob/File 读成 base64 字符串（不含 data URL 前缀）。
// 同构：浏览器与 Node 均可用（Blob.arrayBuffer + btoa，避免依赖浏览器专属的 FileReader）。
// 分块拼接二进制串，避免一次性 spread 超大数组触发参数上限。
export const fileToBase64 = async (blob: Blob): Promise<string> => {
  const bytes = new Uint8Array(await blob.arrayBuffer())
  let binary = ''
  const chunkSize = 0x8000 // 32KB
  for (let i = 0; i < bytes.length; i += chunkSize) {
    binary += String.fromCharCode(...bytes.subarray(i, i + chunkSize))
  }
  return btoa(binary)
}
